import PlainTextCell from 'components/PlainTextCell';

type Props = {
  rowData: Pick<SentinelTeam, 'scheduledForDeletionAt'> & {
    totals?: DeepPartial<
      Pick<NonNullable<SentinelTeam['totals']>, 'assetGroupings'>
    >;
  };
};

export default function EnabledAssetsCell({
  rowData: { totals, scheduledForDeletionAt },
}: Props) {
  return (
    <PlainTextCell
      textAlign="end"
      color={scheduledForDeletionAt ? 'alaskanHusky' : undefined}
      topLine={totals?.assetGroupings?.enabledAssets}
    />
  );
}
